import React from 'react';

// Mijoz bahosi (1-5) — rangli to'ldirilgan yulduzlar. Baho yo'q bo'lsa "—".
export default function RatingStars({ value }) {
  const v = Math.round(Number(value) || 0);
  if (!v) return <span style={{ color: 'var(--text-muted)' }}>—</span>;
  const color = v >= 4 ? '#10b981' : v === 3 ? '#f59e0b' : '#ef4444';
  return (
    <span title={`${v} / 5`} style={{ whiteSpace: 'nowrap', fontSize: 14, letterSpacing: 1 }}>
      <span style={{ color }}>{'★'.repeat(v)}</span>
      <span style={{ color: 'var(--border, #374151)' }}>{'★'.repeat(5 - v)}</span>
    </span>
  );
}
